export const adminV2DefaultLoginPopupSceneSlug = 'default' as const;

export const adminV2LoginPopupSceneSlugs = [
  adminV2DefaultLoginPopupSceneSlug,
  'freeStart',
  'guestCredits',
  'workspaceAccess',
  'checkout',
] as const;

export type AdminV2LoginPopupSceneSlug =
  (typeof adminV2LoginPopupSceneSlugs)[number];

export const adminV2LoginPopupSceneDefinitions = [
  {
    slug: adminV2DefaultLoginPopupSceneSlug,
    label: 'Default',
    title: 'Sign In to Get Free Credits',
    body: 'Sign in to continue and get back to your work.',
  },
  {
    slug: 'freeStart',
    label: 'Free plan',
    title: 'Sign In to Get Free Credits',
    body: 'Sign in to start creating and keep your work connected to your account.',
  },
  {
    slug: 'guestCredits',
    label: 'Guest credits used up',
    title: 'Sign In to Get Free Credits',
    body: 'Sign in to check your account credits and continue from where you left off.',
  },
  {
    slug: 'workspaceAccess',
    label: 'Workspace access',
    title: 'Sign In to Get Free Credits',
    body: 'Sign in to keep your current image and settings while we check access to this feature.',
  },
  {
    slug: 'checkout',
    label: 'Checkout',
    title: 'Sign In to Get Free Credits',
    body: 'Your selection will be saved so you can continue after signing in.',
  },
] as const satisfies ReadonlyArray<{
  slug: AdminV2LoginPopupSceneSlug;
  label: string;
  title: string;
  body: string;
}>;

export function isAdminV2LoginPopupSceneSlug(
  value: unknown
): value is AdminV2LoginPopupSceneSlug {
  return adminV2LoginPopupSceneSlugs.some((slug) => slug === value);
}

export function parseAdminV2LoginPopupSceneSlug(
  value: unknown
): AdminV2LoginPopupSceneSlug {
  if (!isAdminV2LoginPopupSceneSlug(value)) {
    throw new Error(`Unsupported login popup scene: ${String(value)}`);
  }
  return value;
}
